import submitCommand from '../../../services/submitCommand';
import { Step } from '../../steps/models/course';

export const forceCompleteFeedbackTask = (courseId: string, taskInstanceId: Step['id'], requester: string) => {
  const cmd = {
    id: courseId,
    taskInstanceId: taskInstanceId,
    requester: requester,
    initiatingUserId: requester,
  };

  return submitCommand(
    courseId,
    cmd,
    'ForceCompleteFeedbackTask',
    'FeedbackTaskForceCompleted',
    'TaskListInstanceError'
  );
};
